<template>
  <div class="detail-content-block">
    <div class="detail">
      <quick-nav class="detail__navigation" :blocks="detail_blocks" />
      <div v-for="(block,key) in detail_blocks" v-bind:key="_uid+key">
        <component
          v-if="block.show"
          :key="_uid+block+key"
          :is="block.key"
          :property="property"
          @handle-property-data="notify_property_data"
        />
      </div>
      <div class="detail__footer">
        <vb-button
          v-if="cta_status.disabled || !get_availability(property_data.live_price).can_go_to_checkout"
          :vb_options="{
            text: 'Continua',
            variant: 'info',
            icon_disabled: 'lock_v2',
            disabled: true,
            size: 'lg'
          }"
        />
        <div v-else>
          <card-recap v-if="!is_mobile()" class="detail__recap" :property_data="property_data" />
          <custom-link
            :route_name="'checkout'" :wrap="'a'"
            :before_navigation="() => {
              this.$store.commit('liveeps/update_property', property_data)
            }"
          >
            <template #content>
              <vb-button v-if="!is_mobile()" :vb_options="{text: 'Continua', variant: 'info'}" />
              <smart-recap v-else :price="property_data.live_price" />
            </template>
          </custom-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import QuickNav from "@liveeps/components/blocks/detail/quick-nav"
import Heading from "@liveeps/components/blocks/detail/heading"
import Carousel from "@liveeps/components/blocks/detail/carousel"
import Rooms from "@liveeps/components/blocks/detail/rooms"
import Amenities from "@liveeps/components/blocks/detail/amenities/amenities"
import Descriptions from "@liveeps/components/blocks/detail/descriptions"
import KnowBefore from "@liveeps/components/blocks/knowbefore/knowbefore"
import CardRecap from "@liveeps/components/blocks/card-recap"
import SmartRecap from "@liveeps/components/blocks/smart-recap"

export default {
  name: "detail-content-block",

  components: {
    'quick-nav': QuickNav,
    'heading': Heading,
    'carousel': Carousel,
    'rooms': Rooms,
    'amenities': Amenities,
    'descriptions': Descriptions,
    'knowbefore': KnowBefore,
    'card-recap': CardRecap,
    'smart-recap': SmartRecap
  },

  props: {
    property: Object,
  },

  data() {
    return {
      detail_blocks: [],
      property_data: {},
      cta_status: { disabled: true, label: '', variant: '' },
    }
  },

  provide() {
    return {
      cta_status_checker: this.set_cta_status
    }
  },

  computed: {
    ...mapState({
      // stato del modulo liveeps
      selected_solution: state => state.liveeps.selected_solution,
    }),
  },

  watch: {
  },

  created() {
  },

  mounted() {
    this.detail_blocks = [
      {
        key: "heading",
        show: true,
        quick_text: 'Panoramica'
      },
      {
        key: "carousel",
        show: true,
        quick_text: 'Gallery'
      },
      {
        key: "rooms",
        show: true,
        quick_text: 'Camere e prezzi'
      },
      {
        key: "amenities",
        show: true,
        quick_text: 'Cosa troverai'
      },
      {
        key: "descriptions",
        show: true,
        quick_text: 'Descrizione della struttura'
      },
      {
        key: "knowbefore",
        show: true,
        quick_text: 'Informazioni importanti'
      }
    ]
  },

  methods: {

    // Aggiorna data camera selezionata
    notify_property_data(payload){
      this.property_data = payload
    },

    // Stato della cta
    set_cta_status(result) {
      this.cta_status = result
    },

  },
}
</script>

<style lang="scss" scoped>

  .detail {

    &__navigation {
      margin-bottom: $grid-gutter-width*2;
      display: none;

      @include media-breakpoint-up(xl){
        display: flex;
      }
    }

    &__recap {
      margin-bottom: $grid-gutter-width;
    }

    &__footer {
      @extend %section;
      @extend %section_margin;
      text-align: center;
      margin-bottom: $grid-gutter-width*3;

      @include media-breakpoint-up(md){
        text-align: right;
        margin-bottom: inherit;
      }

      .btn {
        line-height: normal;
      }

      ::v-deep {
        .custom-link > * {
          display: block;
        }
      }
    }
  }

</style>